import InPageMessage from '@liveauctioneers/caterwaul-components/lib/InPageMessage/InPageMessage';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';

import { ShippingMethods } from '@/enums/shippingMethod';
import { useAppSelector } from '@/redux/hooks';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { getSellerName } from '@/redux/modules/seller';
import { getSellerUrl } from '@/utils/urls';

import { getShippingTypeMessageId } from './helpers/getShippingTypeMessageId';

type PaymentProcessedNotificationProps = {
    houseId: number;
    shippingMethod: ShippingMethods;
};

export const PaymentProcessedNotification = ({ houseId, shippingMethod }: PaymentProcessedNotificationProps) => {
    const email = useAppSelector(getBidderEmail);
    const houseName = useAppSelector((state) => getSellerName(state, houseId));
    const houseUrl = getSellerUrl(houseId, houseName);
    const messageTranslationId = getShippingTypeMessageId(shippingMethod);

    return (
        <div className="mt-lg">
            <InPageMessage type="success">
                <FormattedMessage
                    id={messageTranslationId}
                    values={{
                        email: <b key="bold-email">{email}</b>,
                        house: (
                            <Link
                                key="checkout-payment-processed-house-link"
                                href={houseUrl}
                                size="sm"
                            >
                                {houseName}
                            </Link>
                        ),
                    }}
                />
            </InPageMessage>
        </div>
    );
};
